var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",attrs:{"extraLarge":"","title":"Reagendar coletas não realizadas","buttons":['cancel']}},[_c('rkm-row',[_c('rkm-col',[_c('Form',{attrs:{"itemsNotRealizados":_vm.itemsNotRealizados,"data":_vm.data,"origem":"coleta"},on:{"exit":_vm.exit}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }